import { Stack, Text } from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import Container from "../../component/Container";
import Section1 from "../../component/Home/Section1";
import Nav from "../../component/Navbar";
import IMAGES from "../../constant/IMAGES";
import useResponsive from "../../hooks/useResponsive";
import SectionNumber from "../../component/Home/SectionNumber";
import SectionAbout from "../../component/SectionAbout";
import SectionFeature1 from "../../component/Home/SectionFeature1";
import SectionFeature2 from "../../component/SectionFeature2";
import SectionContact from "../../component/Home/SectionContact";
import SectionFAQs from "../../component/Home/SectionFAQ";
import SectionFooter from "../../component/Home/SectionFooter";
import HeroBubble from "../../component/HeroBubble";
import { Slide, ToastContainer } from "react-toastify";
import CustomCloseButton from "../../component/CustomCloseButton";
import Loading from "../../component/Loading";
import { set } from "react-datepicker/dist/date_utils";

const Home: React.FC = () => {
  const { isMobileOrTablet } = useResponsive();
  const scrollMargin = isMobileOrTablet ? "80px" : "220px";
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      <Stack
        sx={{
          backgroundImage: `url(${IMAGES.bgS1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "repeat",
          overflow: "hidden",
          backgroundAttachment: "fixed",
        }}
        className="overflow-hidden"
      >
        <Nav />
        <div className="xl:max-w-[90vw] w-full mx-auto flex flex-col px-4 sm:px-8 gap-16 xl:px-0 xl:gap-32 mt-32 xl:mt-52">
          <Section1 />

          <SectionNumber />
          <div id="ve-chung-toi" style={{ scrollMarginTop: scrollMargin }}>
            <SectionAbout />
          </div>
          <div id="tinh-nang-noi-bat" style={{ scrollMarginTop: scrollMargin }}>
            <SectionFeature1 />
          </div>
          <div
            id="tinh-nang-doc-quyen"
            style={{ scrollMarginTop: scrollMargin }}
          >
            <SectionFeature2 />
          </div>
          <div id="lien-he" style={{ scrollMarginTop: scrollMargin }}>
            <SectionContact />
          </div>
          <div id="FAQs" style={{ scrollMarginTop: scrollMargin }}>
            <SectionFAQs />
          </div>
          <SectionFooter />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          transition={Slide}
          className="top-[150px] 2xl:top-[210px] right-5"
          closeButton={CustomCloseButton}
        />
      </Stack>
    </>
  );
};
export default Home;
